// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2sKSy","question":"Question_question__1ugdC","description":"Question_description__3NmRY"};